module.exports = __webpack_public_path__ + "static/media/excludeIcon.0c1c9707.svg";